// import type { Action } from '@reduxjs/toolkit';

import type { BackendEntities } from 'app/lib/betting/betting-entities';
import type { SubscribeAction } from 'app/lib/signalr';
import { addBetFactory } from 'app/modules/BetSlip/actions/addBetFactory';

import { matches, objects, sports } from '../selectors/gridEntities';

export const addBet = addBetFactory(matches, sports, objects);

export type FavoritesSubscribe = SubscribeAction<typeof SUBSCRIBE_TO_FAVORITES>;

export type FavoritesUnsubscribe = SubscribeAction<typeof UNSUBSCRIBE_FROM_FAVORITES>;

export const FAVORITES = 'favorites';
export const SUBSCRIBE_TO_FAVORITES = 'FAVORITES:SUBSCRIBE';
export const UNSUBSCRIBE_FROM_FAVORITES = 'FAVORITES:UNSUBSCRIBE';
export const APPLY_FAVORITES_STATE = 'FAVORITES:APPLY_STATE';
export const CLEANUP_PREMATCH_FAVORITES_CONTENT = 'PREMATCH:CLEANUP_FAVORITES_CONTENT';

export const subscribeToFavorites = (): FavoritesSubscribe => ({
  type: SUBSCRIBE_TO_FAVORITES,
  payload: {
    topic: FAVORITES,
  },
});

export const unsubscribeFromFavorites = (): FavoritesUnsubscribe => ({
  type: UNSUBSCRIBE_FROM_FAVORITES,
  payload: {
    topic: FAVORITES,
  },
});

export const applyFavoritesState = (payload: BackendEntities) => ({
  type: APPLY_FAVORITES_STATE,
  payload,
});

// export const cleanupPrematchFavorites = (): Action<string> => ({
//   type: CLEANUP_PREMATCH_FAVORITES_CONTENT,
// });
